export default "__VITE_ASSET__cd4a96d4__"